import { FxSystem } from "../fx";

// FxSystem for the PlayCanvas renderer. Same pooled/capped particle behaviour
// (reused wholesale on the screen-space overlay), plus a queue of explosion
// "flash" requests the 3D renderer drains to drive real dynamic point-lights, so
// the lit scene genuinely flares on each blast (GDD §10: explosions are protein).

export interface FlashReq { x: number; y: number; radius: number; big: boolean; }

export class PcFxSystem extends FxSystem {
  readonly flashes: FlashReq[] = [];

  override explosion(x: number, y: number, radius: number, fac: number, big: boolean): void {
    super.explosion(x, y, radius, fac, big);
    if (this.flashes.length < 32) this.flashes.push({ x, y, radius, big });
  }
}
